<template>
    <div class="tw-p-4">
        <div class="tw-flex tw-justify-between tw-items-start">
            <h1 class="tw-text-3xl">
                Zusammenfassung aktuelle Reisekostenabrechnung
            </h1>

            <i class="fa fa-times tw-text-2xl tw-cursor-pointer" title="Overlay schließen" @click="closeModal"></i>
        </div>

        <hr class="tw-my-4">

        <table class="cu-table cu-table-striped">
            <tbody>
                <tr>
                    <td>Reiseroute:</td>
                    <td colspan="3" v-text="travelExpenseReport.route"></td>
                </tr>
                <tr>
                    <td>Anlass der Reise:</td>
                    <td colspan="3" v-text="travelExpenseReport.reason_for_trip"></td>
                </tr>
                <tr>
                    <td>Reisedauer:</td>
                    <td colspan="3" v-text="travelDuration"></td>
                </tr>
                <tr>
                    <td>Reiseart:</td>
                    <td v-text="transportationType"></td>
                    <td>Gesamtkosten:</td>
                    <td v-text="Helpers.formatPrice(Helpers.transportationTotalCosts())"></td>
                </tr>
                <tr>
                    <td>Übernachtung:</td>
                    <td v-text="travelExpenseReport.travel_information.overnight_stay.hotel || '-'">-</td>
                    <td>Gesamtkosten:</td>
                    <td v-text="Helpers.formatPrice(Helpers.overnightStayTotalCosts())"></td>
                </tr>
                <tr>
                    <td>Frühstück:</td>
                    <td></td>
                    <td>Abzug:</td>
                    <td v-text="'-' + Helpers.formatPrice(Helpers.breakfastTotalCosts())"></td>
                </tr>
                <tr>
                    <td>Sonstige Reisekosten:</td>
                    <td></td>
                    <td>Gesamtkosten:</td>
                    <td v-text="Helpers.formatPrice(Helpers.otherCostsTotal())"></td>
                </tr>
                <tr>
                    <td>Verpflegungsmehraufwand:</td>
                    <td></td>
                    <td>Gesamtkosten:</td>
                    <td v-text="Helpers.formatPrice(Helpers.dailyAllowanceTotalCosts())"></td>
                </tr>
                <tr>
                    <td>Kostenstelle:</td>
                    <td colspan="3" v-text="costCenterName"></td>
                </tr>
                <tr>
                    <td>Kostenträger:</td>
                    <td colspan="3" v-text="costCarrierName"></td>
                </tr>
                <tr>
                    <td colspan="4">
                        <div class="tw-flex tw-justify-between tw-font-bold tw-text-2xl">
                            <div>
                                Gesamtbetrag Reisekostenabrechnung:
                            </div>
                            <div v-text="Helpers.formatPrice(Helpers.totalCosts())"></div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import moment from 'moment';
    import {Constants, TravelTypes, OvernightPaymentTypes, Helpers} from "./TravelExpenseReport";

    export default {
        props: {
            travelExpenseReport: {
                type: Object,
                required: true,
            },
            costCenters: {
                type: Array,
                required: true,
            },
            costCarriers: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                Constants: Constants,
                TravelTypes: TravelTypes,
                OvernightPaymentTypes: OvernightPaymentTypes,
                Helpers: new Helpers(this.travelExpenseReport),
            }
        },

        methods: {
            closeModal() {
                this.$emit('close');
            },

            getCostCarrierById(costCarriers, id, path) {
                let result = null;

                costCarriers.forEach(costCarrier => {
                    if (costCarrier.id === id) {
                        result = costCarrier;
                        path.push(costCarrier.label);
                    }

                    if (!! costCarrier.children && costCarrier.children.length > 0) {
                        let c = this.getCostCarrierById(costCarrier.children, id, path);

                        if (!! c) {
                            result = c;
                            path.push(costCarrier.label);
                        }
                    }
                });

                return result;
            }
        },

        computed: {
            travelDuration() {
                let start = null;
                let end = null;

                this.travelExpenseReport.travel_information.period.forEach(day => {
                    if (day.date === null) {
                        return;
                    }

                    let date = moment(day.date);

                    if (start === null || date.isBefore(start)) {
                        start = day.date;
                    }
                    if (end === null || date.isAfter(end)) {
                        end = day.date;
                    }
                });

                if (! start || ! end) {
                    return '-';
                }

                return moment(start).format('DD.MM.YYYY') + ' - ' + moment(end).format('DD.MM.YYYY');
            },

            transportationType() {
                let transportationType = '-';

                this.TravelTypes.forEach(item => {
                    if (item.value === this.travelExpenseReport.travel_information.transportation_type) {
                        transportationType = item.title;
                    }
                })

                return transportationType;
            },

            costCarrierName() {
                if (this.travelExpenseReport.cost_carrier_id > 0) {
                    let name = [];
                    this.getCostCarrierById(this.costCarriers, this.travelExpenseReport.cost_carrier_id, name);

                    return name.reverse().join(' > ');
                }

                return '-';
            },

            costCenterName() {
                let name = '-';

                if (this.travelExpenseReport.cost_center_id > 0) {
                    this.costCenters.forEach(costCenter => {
                        if (costCenter.id === this.travelExpenseReport.cost_center_id) {
                            name = costCenter.name;
                        }
                    });
                }

                return name;
            }
        },

        mounted() {
            //
        }
    }
</script>